import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Label = ({ children }) => (
  <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00D1FF]">
    {children}
  </span>
);

export const SectionHeading = ({ label, title, className = "" }) => (
  <div className={className}>
    {label && <div className="mb-4"><Label>{label}</Label></div>}
    <h2 className="font-head text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-metallic leading-[1.05]">
      {title}
    </h2>
  </div>
);
